import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const { public: { sentry } } = useRuntimeConfig()

  if (!sentry.dsn)
    return

  if (process.env.NODE_ENV === 'development')
    return

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: sentry.dsn,
    environment: process.env.NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration({
        router,
      }),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', 'https://www.starlinepool.com'],
  })
})
